<script setup>
import "altcha";
import "altcha/i18n/de"
import "altcha/i18n/en"

import { onMounted, onUnmounted, useTemplateRef } from "vue";

const altchaWidget = useTemplateRef("altchaWidget");
const props = defineProps({
    modelValue: {
        type: String,
        required: false,
    },
});

const emit = defineEmits(["update:modelValue"]);

const onStateChange = (e) => {
    if (!("detail" in e)) {
        return;
    }

    const { payload, state } = e.detail;

    if (state === "verified" && payload) {
        emit("update:modelValue", payload);
        return;
    }

    emit("update:modelValue", "");
};

onMounted(() => {
    altchaWidget.value.addEventListener("statechange", onStateChange);
});

onUnmounted(() => {
    altchaWidget.value.removeEventListener("statechange", onStateChange);
});
</script>

<template>
    <!-- route.api.captcha.challenge -->
    <altcha-widget
        ref="altchaWidget"
        challenge="/api/koch/captcha/challenge"
    ></altcha-widget>
</template>
